import { TimeSlot } from 'store/booking/appointment/timeSlots/types';
import { createReducer } from '@reduxjs/toolkit';
import * as actions from 'store/booking/actions';
import unionBy from 'lodash/unionBy';
import sortBy from 'lodash/sortBy';
import isEmpty from 'lodash/isEmpty';

export type Npv2State = Readonly<{
  data: { [key: string]: TimeSlot[] };
  npv2ProviderId: string;
}>;

export const npv2InitialState: Npv2State = {
  data: {},
  npv2ProviderId: ''
};

export const npv2Reducer = createReducer(npv2InitialState, {
  [actions.SET_SLOTS_PROVIDER_LOCATION_IDS]: (state, action) => {
    if (!state.data[action.payload]) {
      state.data[action.payload] = [];
    }
  },
  [actions.SET_NPV2_PROVIDER_LOCATION_ID]: (state, action) => {
    state.npv2ProviderId = action.payload;
  },
  [actions.GET_NPV2_LOCATION_TIME_SLOTS_SUCCESS]: (state, action) => {
    const { npv2ProviderId } = state;
    const isNpv2ProviderDefined = !isEmpty(npv2ProviderId);
    if (isNpv2ProviderDefined && state.data[npv2ProviderId]) {
      const slots = state.data[npv2ProviderId];
      let combinedSlots = unionBy(action.payload, slots, 'id');
      combinedSlots = unionBy(action.payload, combinedSlots, 'datetime');
      const sortedSlots = sortBy(combinedSlots, ['datetime']);
      state.data = { ...state.data, [npv2ProviderId]: sortedSlots };
    }
  },
  [actions.CLEAR_NPV2_STATE]: () => npv2InitialState
});
